import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faCheck, faUser, faLink } from '@fortawesome/free-solid-svg-icons';
import { API } from '../API';
import { DIALOG_TYPES } from './ModalDialog';

const _api = Symbol();

class ForgotUsername extends BaseElement {
	constructor() {
		super();

		this.library.add(faCheck, faUser, faLink);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					
				}
				
				.centered {
					display: flex;
					justify-content: center;
				}
				input {
					width: 10em;
					margin-right: 0.5em;
				}
				a {
					font-size: 0.85em;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();
			if(!this.api)
				throw new Error('api property not set!');
			
			const detail = Object.fromEntries(new FormData(e.target));
			e.target.reset();
			const { mail } = detail;
			const response = await this.api.sendUsername(mail);
			this.emit('show-dialog', {
				title: 'Username Sent',
				message: response,
				type: DIALOG_TYPES.DIALOG_TYPE_INFO
			});
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Auth Service Error',
				message: err instanceof TypeError ? 'Failed to connect to authentication service.' : err.message,
				type: DIALOG_TYPES.DIALOG_TYPE_ERROR
			});
		}
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api = null;
	}
	render() {
		return html`
			<h4>Username recovery</h4>
			<p>
				Please enter your email address. Your username will be emailed to you.
			</p>
			<div class="centered">
				<form @submit="${e => this.handleSubmit(e)}">
					<input type="text" placeholder="Email Address" name="mail"/>
					<button type="submit">
						<i class="icon fas fa-check"></i>
						Submit
					</button>
				</form>
			</div>
		`;
	}
}

customElements.define('pp-forgot-username', ForgotUsername);